import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
const toast = {
  show: ({ title, duration = 2000, icon }) => {
    Toast({
      message: title,
      duration,
      icon
    })
  }
}
export default toast
